import React from 'react';
import './ProductJourneyStill.css';

const STILLS = {
  projects: {
    src: '/virgil_screenshots/current/claude-project-manager.jpg',
    alt: "Virgil's cloud-synced project shelf, with the Inferno project and its version history open",
  },
  idea: {
    src: '/virgil_screenshots/current/virgil-writing-real.jpg',
    alt: 'The real Virgil screenplay editor and creative chat workspace with an Inferno scene open',
  },
  storyboard: {
    src: '/virgil_screenshots/current/virgil-storyboard-real.jpg',
    alt: 'The real Virgil Storyboard Studio showing Inferno images arranged into shots',
  },
  video: {
    src: '/virgil_screenshots/current/virgil-video-real.jpg',
    alt: 'The real Virgil Video Studio showing generated Inferno clips on a multi-track timeline',
  },
};

export const getProductStill = (type) => STILLS[type] || STILLS.idea;

// `crop` ({ x, y, zoom }, x and y in percent) frames one part of the still,
// for cards too small to show the whole screen legibly.
export default function ProductJourneyStill({ type, expanded = false, loading, crop }) {
  const still = getProductStill(type);
  const cropStyle = crop
    ? {
        objectPosition: `${crop.x}% ${crop.y}%`,
        transformOrigin: `${crop.x}% ${crop.y}%`,
        transform: `scale(${crop.zoom || 1})`,
      }
    : undefined;

  return (
    <div
      className={`product-journey-still${expanded ? ' is-expanded' : ''}${crop ? ' is-cropped' : ''}`}
    >
      <img src={still.src} alt={still.alt} loading={loading} decoding="async" style={cropStyle} />
    </div>
  );
}
